// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-agreement-report .container-fluid {
  max-width: 1400px;
  margin: 0 auto;
}
.customer-agreement-report .page-header .page-title {
  font-size: 2rem;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}
.customer-agreement-report .page-header .page-title i {
  color: #764ba2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}
.customer-agreement-report .page-header .page-subtitle {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0;
  color: #6c757d;
}
.customer-agreement-report .form-label-required {
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}
.customer-agreement-report .form-label-required::after {
  content: " *";
  color: #ef4444;
}
.customer-agreement-report .card {
  border: none;
  border-radius: 16px;
  transition: all 0.3s ease;
  overflow: hidden;
}
.customer-agreement-report .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}
.customer-agreement-report .card.selection-card {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .customer-agreement-report .card.selection-card {
  background: rgba(33, 37, 41, 0.95);
  border-color: rgba(102, 126, 234, 0.2);
}
.customer-agreement-report .card.details-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .customer-agreement-report .card.details-card {
  background: rgba(33, 37, 41, 0.98);
}
.customer-agreement-report .card .card-header {
  border-radius: 16px 16px 0 0 !important;
  padding: 1.5rem 2rem;
  border-bottom: none;
  position: relative;
}
.customer-agreement-report .card .card-header.gradient-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}
.customer-agreement-report .card .card-header.gradient-header::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%);
}
.customer-agreement-report .card .card-header.gradient-header h5 {
  margin: 0;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.customer-agreement-report .card .card-header.details-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  color: #374151;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
}
.customer-agreement-report .card .card-header.details-header .details-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.customer-agreement-report .card .card-header.details-header .details-title {
  font-weight: 600;
  color: #667eea;
  margin-bottom: 0.5rem;
}
.customer-agreement-report .card .card-header.details-header .details-title i {
  color: #764ba2;
}
.customer-agreement-report .card .card-header.details-header .details-badges {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.customer-agreement-report .card .card-body {
  border-radius: 0 0 16px 16px;
  padding: 2rem;
}
.customer-agreement-report .action-buttons-group {
  display: flex;
  gap: 12px;
  width: 100%;
}
.customer-agreement-report .action-buttons-group .btn-report-generate {
  flex: 1 1;
  padding: 12px 24px;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}
.customer-agreement-report .action-buttons-group .btn-report-generate:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
}
.customer-agreement-report .action-buttons-group .btn-report-generate:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.customer-agreement-report .action-buttons-group .btn-report-generate i {
  margin-right: 8px;
}
.customer-agreement-report .action-buttons-group .btn-clear {
  padding: 12px 20px;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  background: transparent;
  border: 2px solid #e5e7eb;
  color: #6b7280;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}
.customer-agreement-report .action-buttons-group .btn-clear:hover:not(:disabled) {
  border-color: #ef4444;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}
.customer-agreement-report .action-buttons-group .btn-clear:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.customer-agreement-report .action-buttons-group .btn-clear .clear-icon {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
}
.customer-agreement-report .action-buttons-export {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.customer-agreement-report .action-buttons-export .btn-action-preview,
.customer-agreement-report .action-buttons-export .btn-action-print,
.customer-agreement-report .action-buttons-export .btn-action-excel {
  border-radius: 10px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
}
.customer-agreement-report .action-buttons-export .btn-action-preview::before,
.customer-agreement-report .action-buttons-export .btn-action-print::before,
.customer-agreement-report .action-buttons-export .btn-action-excel::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s ease;
}
.customer-agreement-report .action-buttons-export .btn-action-preview:hover::before,
.customer-agreement-report .action-buttons-export .btn-action-print:hover::before,
.customer-agreement-report .action-buttons-export .btn-action-excel:hover::before {
  width: 200px;
  height: 200px;
}
.customer-agreement-report .action-buttons-export .btn-action-preview .btn-text,
.customer-agreement-report .action-buttons-export .btn-action-print .btn-text,
.customer-agreement-report .action-buttons-export .btn-action-excel .btn-text {
  position: relative;
  z-index: 2;
}
.customer-agreement-report .action-buttons-export .btn-action-preview i,
.customer-agreement-report .action-buttons-export .btn-action-print i,
.customer-agreement-report .action-buttons-export .btn-action-excel i {
  position: relative;
  z-index: 2;
}
.customer-agreement-report .action-buttons-export .btn-action-preview {
  background: rgba(13, 202, 240, 0.1);
  border-color: rgba(13, 202, 240, 0.2);
  color: #0dcaf0;
}
.customer-agreement-report .action-buttons-export .btn-action-preview:hover {
  background: linear-gradient(135deg, #0dcaf0 0%, #0aa2c0 100%);
  border-color: #0dcaf0;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(13, 202, 240, 0.4);
}
.customer-agreement-report .action-buttons-export .btn-action-print {
  background: rgba(108, 117, 125, 0.1);
  border-color: rgba(108, 117, 125, 0.2);
  color: #6c757d;
}
.customer-agreement-report .action-buttons-export .btn-action-print:hover {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  border-color: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.4);
}
.customer-agreement-report .action-buttons-export .btn-action-excel {
  background: rgba(25, 135, 84, 0.1);
  border-color: rgba(25, 135, 84, 0.2);
  color: #198754;
}
.customer-agreement-report .action-buttons-export .btn-action-excel:hover {
  background: linear-gradient(135deg, #198754 0%, #157347 100%);
  border-color: #198754;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 135, 84, 0.4);
}
.customer-agreement-report .detail-badge {
  font-weight: 500;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
.customer-agreement-report .detail-badge:hover {
  transform: scale(1.05);
}
.customer-agreement-report .detail-badge.customer-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}
.customer-agreement-report .detail-badge.code-badge {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border-color: #f093fb;
}
.customer-agreement-report .detail-badge.date-badge {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  border-color: #4facfe;
}
.customer-agreement-report .alert {
  border: none;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.customer-agreement-report .alert.alert-danger {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  border-left: 4px solid #dc3545;
}
[data-coreui-theme=dark] .customer-agreement-report .alert.alert-danger {
  background: rgba(220, 53, 69, 0.15);
  color: #f8d7da;
}
.customer-agreement-report .alert i {
  margin-right: 0.5rem;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.agreement-a4-preview {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 2rem;
  border-radius: 16px;
}
.agreement-a4-preview > * {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  background: white;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 20px 40px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05);
  padding: 12mm;
  border-radius: 8px;
  position: relative;
}
.agreement-a4-preview > *::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px 8px 0 0;
  opacity: 0.3;
}
.agreement-a4-preview.two-page-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
}
.agreement-a4-preview.two-page-preview > * {
  width: auto;
  min-height: auto;
  margin: 0;
  background: transparent;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}
.agreement-a4-preview.two-page-preview > *::before {
  display: none;
}
.agreement-a4-preview.two-page-preview .preview-page {
  width: 210mm;
  min-height: 297mm;
  background: white;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 20px 40px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.08);
  padding: 12mm;
  border-radius: 8px;
  position: relative;
}
.agreement-a4-preview.two-page-preview .preview-page::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px 8px 0 0;
}
.agreement-a4-preview.two-page-preview .preview-page .page-label {
  position: absolute;
  top: -28px;
  right: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 6px 6px 0 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-preview {
  background: #f8fafc !important;
  padding: 1rem !important;
}
.modal-preview > * {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 10px 20px rgba(0, 0, 0, 0.08) !important;
}
.modal-preview > *::before {
  opacity: 0.5;
}

.agreement-preview-card {
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
}
.agreement-preview-card .card-body {
  padding: 0 !important;
}
.agreement-preview-card .agreement-a4-preview {
  background: transparent;
  padding: 0;
  border-radius: 0;
}
.agreement-preview-card .agreement-a4-preview > * {
  box-shadow: none;
  border-radius: 0;
}
.agreement-preview-card .agreement-a4-preview > *::before {
  display: none;
}
.agreement-preview-card .agreement-a4-preview .agreement-wrap {
  width: 100%;
  border: 2px solid #000;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
}
.agreement-preview-card .agreement-a4-preview .header-grid {
  display: grid;
  grid-template-columns: 100px 1fr 180px;
  border-bottom: 2px solid #000;
  background: #ffffff;
}
.agreement-preview-card .agreement-a4-preview .logo-cell {
  border-right: 2px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background: #ffffff;
}
.agreement-preview-card .agreement-a4-preview .title-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  color: #000;
  text-align: center;
  padding: 12px;
}
.agreement-preview-card .agreement-a4-preview .meta-cell {
  border-left: 2px solid #000;
  padding: 8px;
  background: #ffffff;
}
.agreement-preview-card .agreement-a4-preview .meta-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.agreement-preview-card .agreement-a4-preview .meta-table td {
  border: 1px solid #000;
  padding: 6px 8px;
  background: #ffffff;
  vertical-align: middle;
}
.agreement-preview-card .agreement-a4-preview .meta-table strong {
  color: #000;
  font-weight: 600;
}
.agreement-preview-card .agreement-a4-preview .customer-info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin: 0;
}
.agreement-preview-card .agreement-a4-preview .customer-info-table td {
  border: 1px solid #000;
  padding: 10px 12px;
  background: #ffffff;
  vertical-align: middle;
}
.agreement-preview-card .agreement-a4-preview .customer-info-table .label-cell {
  background: #f8f9fa;
  font-weight: 600;
  width: 15%;
  color: #000;
}
.agreement-preview-card .agreement-a4-preview .customer-info-table .value-cell {
  background: #ffffff;
  color: #000;
}
.agreement-preview-card .agreement-a4-preview .section .row {
  display: grid;
  grid-template-columns: 200px 1fr;
  border-bottom: 1px solid #000;
}
.agreement-preview-card .agreement-a4-preview .section .row .label {
  border-right: 1px solid #000;
  font-weight: 600;
  padding: 12px 14px;
  background: #f8f9fa;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.agreement-preview-card .agreement-a4-preview .section .row .value {
  padding: 12px 14px;
  background: #ffffff;
  color: #000;
  display: flex;
  align-items: center;
  min-height: 45px;
  font-size: 14px;
}
.agreement-preview-card .agreement-a4-preview .notes {
  min-height: 60px;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  padding: 12px;
  background: #ffffff;
}
.agreement-preview-card .agreement-a4-preview .notes .note-title {
  font-weight: 700;
  margin-bottom: 8px;
  color: #000;
  font-size: 15px;
}
.agreement-preview-card .agreement-a4-preview .terms {
  font-size: 16px;
  line-height: 1.5;
  padding: 12px;
  background: #f8f9fa;
  color: #333;
}
.agreement-preview-card .agreement-a4-preview .terms > div {
  margin-bottom: 4px;
  padding-left: 8px;
  border-left: 2px solid #ddd;
}
.agreement-preview-card .agreement-a4-preview .signatures {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 2px solid #000;
}
.agreement-preview-card .agreement-a4-preview .sig-cell {
  border-left: 1px solid #000;
  padding: 20px 16px;
  height: 100px;
  text-align: center;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.agreement-preview-card .agreement-a4-preview .sig-cell:first-child {
  border-left: none;
  border-right: 1px solid #000;
}
.agreement-preview-card .agreement-a4-preview .sig-cell strong {
  color: #000;
  margin-bottom: 6px;
  font-size: 15px;
  font-weight: 700;
}
.agreement-preview-card .agreement-a4-preview .muted {
  color: #666;
}
.agreement-preview-card .agreement-a4-preview .small {
  font-size: 12px;
}

.modal .modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.98);
}
[data-coreui-theme=dark] .modal .modal-content {
  background: rgba(33, 37, 41, 0.98);
}
.modal .modal-header.gradient-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  border-radius: 20px 20px 0 0;
  padding: 1.5rem 2rem;
  border-bottom: none;
}
.modal .modal-header.gradient-header .modal-title {
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.modal .modal-header.gradient-header .modal-title i {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}
.modal .modal-header.gradient-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.8;
  transition: all 0.2s ease;
}
.modal .modal-header.gradient-header .btn-close:hover {
  opacity: 1;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .customer-agreement-report .container-fluid {
    padding: 0 1rem;
  }
  .customer-agreement-report .page-header .page-title {
    font-size: 1.5rem;
    flex-direction: column;
    align-items: flex-start;
  }
  .customer-agreement-report .page-header .page-title i {
    margin-bottom: 0.25rem;
    margin-right: 0;
  }
  .customer-agreement-report .action-buttons-group {
    flex-direction: column;
  }
  .customer-agreement-report .action-buttons-group .btn-report-generate {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  .customer-agreement-report .action-buttons-group .btn-clear {
    width: 100%;
    height: 48px;
  }
  .customer-agreement-report .action-buttons-export {
    flex-direction: column;
    width: 100%;
  }
  .customer-agreement-report .action-buttons-export .btn-action-preview,
  .customer-agreement-report .action-buttons-export .btn-action-print,
  .customer-agreement-report .action-buttons-export .btn-action-excel {
    width: 100%;
    justify-content: center;
  }
  .customer-agreement-report .details-header-content {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 1rem;
  }
  .customer-agreement-report .details-badges {
    width: 100%;
  }
  .customer-agreement-report .action-buttons-export {
    width: 100%;
  }
  .customer-agreement-report .agreement-a4-preview {
    padding: 1rem;
  }
  .customer-agreement-report .agreement-a4-preview > * {
    width: 100%;
    min-height: auto;
    padding: 8mm;
  }
  .customer-agreement-report .agreement-a4-preview.two-page-preview {
    gap: 1.5rem;
    padding: 1rem;
  }
  .customer-agreement-report .agreement-a4-preview.two-page-preview .preview-page {
    width: 100%;
    min-height: auto;
    padding: 8mm;
  }
  .customer-agreement-report .agreement-a4-preview.two-page-preview .preview-page .page-label {
    font-size: 10px;
    padding: 3px 8px;
    top: -24px;
  }
}
@media (max-width: 576px) {
  .customer-agreement-report .details-badges .detail-badge {
    font-size: 0.75rem;
    padding: 0.375rem 0.625rem;
  }
  .customer-agreement-report .action-buttons-export .btn-action-preview .btn-text,
  .customer-agreement-report .action-buttons-export .btn-action-print .btn-text,
  .customer-agreement-report .action-buttons-export .btn-action-excel .btn-text {
    display: none;
  }
}
@media print {
  .customer-agreement-report .page-header,
  .customer-agreement-report .card:not(.agreement-preview-card),
  .customer-agreement-report .alert {
    display: none !important;
  }
  .agreement-a4-preview {
    padding: 0 !important;
    background: none !important;
    border-radius: 0 !important;
  }
  .agreement-a4-preview > * {
    width: auto !important;
    min-height: auto !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
  .agreement-a4-preview > *::before {
    display: none !important;
  }
}
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.agreement-preview-card {
  animation: slideInUp 0.5s ease-out;
}

.btn:focus,
.form-control:focus,
.form-select:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15) !important;
  border-color: #667eea !important;
  outline: none;
}

.card:hover .details-header {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;
}

.detail-badge:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

[data-coreui-theme=dark] .customer-agreement-report .page-title {
  color: #8da3f0;
}
[data-coreui-theme=dark] .customer-agreement-report .page-subtitle {
  color: #9ca3af;
}
[data-coreui-theme=dark] .customer-agreement-report .agreement-a4-preview {
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
}
[data-coreui-theme=dark] .customer-agreement-report .selection-card,
[data-coreui-theme=dark] .customer-agreement-report .details-card {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
}

[data-coreui-theme=dark] .customer-agreement-report {
  color: #e5e7eb;
}
[data-coreui-theme=dark] .customer-agreement-report .form-label-required,
[data-coreui-theme=dark] .customer-agreement-report .page-subtitle,
[data-coreui-theme=dark] .customer-agreement-report label,
[data-coreui-theme=dark] .customer-agreement-report small {
  color: #e5e7eb;
}
[data-coreui-theme=dark] .customer-agreement-report .card.selection-card,
[data-coreui-theme=dark] .customer-agreement-report .card.details-card {
  background: rgba(17, 24, 39, 0.95);
  color: #e5e7eb;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
[data-coreui-theme=dark] .customer-agreement-report .details-card .details-header {
  background: linear-gradient(135deg, #111827 0%, #1f2937 100%) !important;
  color: #e5e7eb;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
[data-coreui-theme=dark] .customer-agreement-report input.form-control,
[data-coreui-theme=dark] .customer-agreement-report .form-select {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: #374151 !important;
}
[data-coreui-theme=dark] .customer-agreement-report input.form-control::placeholder {
  color: #9ca3af;
}
[data-coreui-theme=dark] .customer-agreement-report .alert.alert-danger {
  background: rgba(185, 28, 28, 0.15);
  color: #fecaca;
  border-left: 4px solid #ef4444;
}
[data-coreui-theme=dark] .customer-agreement-report .btn-report-generate {
  color: #ffffff;
}
[data-coreui-theme=dark] .customer-agreement-report .btn-clear {
  color: #9ca3af;
  border-color: #4b5563;
}
[data-coreui-theme=dark] .customer-agreement-report .btn-clear:hover {
  color: #f87171;
  border-color: #ef4444;
}

.cursor-pointer {
  cursor: pointer !important;
}

.glassmorphism {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.gradient-text {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.fade-in-up {
  animation: fadeInUp 0.5s ease forwards;
}

.customer-agreement-report .page-header .page-title {
  font-size: 2rem;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}
.customer-agreement-report .page-header .page-title i {
  color: #3b82f6;
}
.customer-agreement-report .page-header .page-subtitle {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0;
}
.customer-agreement-report .form-label-required {
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}
.customer-agreement-report .form-label-required::after {
  content: " *";
  color: #ef4444;
}
.customer-agreement-report .card {
  border: none;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.customer-agreement-report .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}
.customer-agreement-report .card .card-header {
  border-radius: 12px 12px 0 0 !important;
  padding: 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.customer-agreement-report .card .card-header.bg-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
}
.customer-agreement-report .card .card-header.bg-light {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  color: #374151;
}
.customer-agreement-report .card .card-header.bg-light .badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
}
.customer-agreement-report .card .card-header h5 {
  margin: 0;
  font-weight: 600;
}
.customer-agreement-report .card .card-body {
  border-radius: 0 0 12px 12px;
}
.customer-agreement-report .btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: none;
}
.customer-agreement-report .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.customer-agreement-report .btn.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
}
.customer-agreement-report .btn.btn-outline-info {
  border: 1px solid #06b6d4;
  color: #06b6d4;
}
.customer-agreement-report .btn.btn-outline-info:hover {
  background: #06b6d4;
  border-color: #06b6d4;
}
.customer-agreement-report .btn.btn-outline-secondary {
  border: 1px solid #6b7280;
  color: #6b7280;
}
.customer-agreement-report .btn.btn-outline-secondary:hover {
  background: #6b7280;
  border-color: #6b7280;
}
.customer-agreement-report .btn.btn-outline-success {
  border: 1px solid #10b981;
  color: #10b981;
}
.customer-agreement-report .btn.btn-outline-success:hover {
  background: #10b981;
  border-color: #10b981;
}
.customer-agreement-report .btn i {
  font-size: 0.875rem;
}
.customer-agreement-report .alert {
  border: none;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.customer-agreement-report .alert.alert-danger {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  border-left: 4px solid #dc2626;
}
.customer-agreement-report .alert i {
  margin-right: 0.5rem;
}
.customer-agreement-report .badge {
  font-weight: 500;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
}
.customer-agreement-report .badge.bg-info {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%) !important;
}
.customer-agreement-report .badge.bg-secondary {
  background: linear-gradient(135deg, #64748b 0%, #475569 100%) !important;
}
.customer-agreement-report .badge.bg-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
}

.agreement-a4-preview {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 2rem;
  border-radius: 12px;
}
.agreement-a4-preview > * {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  background: white;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.1), 0 20px 40px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05);
  padding: 12mm;
  border-radius: 8px;
  position: relative;
}
.agreement-a4-preview > *::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #1e40af 100%);
  border-radius: 8px 8px 0 0;
}

.modal-preview {
  background: #f8fafc !important;
  padding: 1rem !important;
}
.modal-preview > * {
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.1), 0 10px 20px rgba(0, 0, 0, 0.08) !important;
}

.agreement-preview-card {
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
}
.agreement-preview-card .card-body {
  padding: 0 !important;
}
.agreement-preview-card .agreement-a4-preview {
  background: transparent;
  padding: 0;
  border-radius: 0;
}
.agreement-preview-card .agreement-a4-preview > * {
  box-shadow: none;
  border-radius: 0;
}
.agreement-preview-card .agreement-a4-preview > *::before {
  display: none;
}

@media (max-width: 768px) {
  .customer-agreement-report .page-header .page-title {
    font-size: 1.5rem;
    flex-direction: column;
    align-items: flex-start;
  }
  .customer-agreement-report .page-header .page-title i {
    margin-bottom: 0.25rem;
    margin-right: 0;
  }
  .customer-agreement-report .d-flex.gap-2 {
    flex-direction: column;
    gap: 0.5rem !important;
  }
  .customer-agreement-report .d-flex.gap-2 .btn {
    width: 100%;
    justify-content: center;
  }
  .customer-agreement-report .agreement-a4-preview {
    padding: 1rem;
  }
  .customer-agreement-report .agreement-a4-preview > * {
    width: 100%;
    min-height: auto;
    padding: 8mm;
  }
}
@media (max-width: 576px) {
  .customer-agreement-report .card-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 1rem;
  }
  .customer-agreement-report .card-header .d-flex.gap-3 {
    flex-wrap: wrap;
  }
  .customer-agreement-report .card-header .d-flex.gap-2 {
    width: 100%;
  }
  .customer-agreement-report .card-header .d-flex.gap-2 .btn {
    flex: 1 1;
    min-width: 0;
  }
  .customer-agreement-report .card-header .d-flex.gap-2 .btn span {
    display: none;
  }
  .customer-agreement-report .card-header .d-flex.gap-2 .btn::after {
    content: attr(data-label);
  }
}
@media print {
  .customer-agreement-report .page-header,
  .customer-agreement-report .card:not(.agreement-preview-card),
  .customer-agreement-report .btn,
  .customer-agreement-report .alert {
    display: none !important;
  }
  .agreement-a4-preview {
    padding: 0 !important;
    background: none !important;
    border-radius: 0 !important;
  }
  .agreement-a4-preview > * {
    width: auto !important;
    min-height: auto !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
  .agreement-a4-preview > *::before {
    display: none !important;
  }
}
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.agreement-preview-card {
  animation: slideInUp 0.5s ease-out;
}

.btn:focus,
.form-control:focus,
.form-select:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  border-color: #3b82f6 !important;
}

.card:hover .card-header.bg-light {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;
}

.badge:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

@media (prefers-color-scheme: dark) {
  .customer-agreement-report .page-title {
    color: #60a5fa;
  }
  .customer-agreement-report .page-subtitle {
    color: #9ca3af;
  }
  .customer-agreement-report .agreement-a4-preview {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/CustomerAgreementReport/CustomerAgreementReport.scss"],"names":[],"mappings":"AAIE;EACE,iBAAA;EACA,cAAA;AAHJ;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AALN;AAOM;EACE,cAAA;EACA,iDAAA;AALR;AASI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPN;AAWE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AATJ;AAWI;EACE,aAAA;EACA,cAAA;AATN;AAcE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,2BAAA;EACA,sDAAA;AAZN;AAeI;EACE,2BAAA;EACA,qCAAA;EACA,0CAAA;AAbN;AAeM;EACE,kCAAA;EACA,sCAAA;AAbR;AAiBI;EACE,qCAAA;EACA,2BAAA;EACA,0CAAA;AAfN;AAiBM;EACE,kCAAA;AAfR;AAmBI;EACE,uCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAjBN;AAmBM;EACE,wEAAA;EACA,uBAAA;AAjBR;AAmBQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kGAAA;AAjBV;AAuBQ;EACE,SAAA;EACA,gBAAA;EACA,yCAAA;AArBV;AAyBM;EACE,6DAAA;EACA,cAAA;EACA,iDAAA;AAvBR;AAyBQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAvBV;AA0BQ;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAxBV;AA0BU;EACE,cAAA;AAxBZ;AA4BQ;EACE,aAAA;EACA,YAAA;EACA,eAAA;AA1BV;AA+BI;EACE,4BAAA;EACA,aAAA;AA7BN;AAkCE;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAhCJ;AAkCI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,yBAAA;AAhCN;AAkCM;EACE,2BAAA;EACA,+CAAA;EACA,6DAAA;AAhCR;AAmCM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAjCR;AAoCM;EACE,iBAAA;AAlCR;AAsCI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApCN;AAsCM;EACE,qBAAA;EACA,cAAA;EACA,mCAAA;AApCR;AAuCM;EACE,YAAA;EACA,mBAAA;AArCR;AAwCM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAtCR;AA2CE;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAzCJ;AA2CI;;;EAGE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AAzCN;AA2CM;;;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;AAvCR;AA0CM;;;EACE,YAAA;EACA,aAAA;AAtCR;AAyCM;;;EACE,kBAAA;EACA,UAAA;AArCR;AAwCM;;;EACE,kBAAA;EACA,UAAA;AApCR;AAwCI;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;AAtCN;AAwCM;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,8CAAA;AAtCR;AA0CI;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAxCN;AA0CM;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AAxCR;AA4CI;EACE,kCAAA;EACA,oCAAA;EACA,cAAA;AA1CN;AA4CM;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,6CAAA;AA1CR;AAgDE;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;AA9CJ;AAgDI;EACE,sBAAA;AA9CN;AAiDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AA/CN;AAkDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AAhDN;AAmDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AAjDN;AAsDE;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yCAAA;AApDJ;AAsDI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AApDN;AAsDM;EACE,mCAAA;EACA,cAAA;AApDR;AAwDI;EACE,oBAAA;EACA,iDAAA;AAtDN;;AA4DA;EACE,6DAAA;EACA,aAAA;EACA,mBAAA;AAzDF;AA2DE;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,wGACE;EAGF,aAAA;EACA,kBAAA;EACA,kBAAA;AA5DJ;AA+DI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,0BAAA;EACA,YAAA;AA7DN;AAkEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAhEJ;AAkEI;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAhEN;AAkEM;EACE,aAAA;AAhER;AAoEI;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,wGACE;EAGF,aAAA;EACA,kBAAA;EACA,kBAAA;AArEN;AAuEM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,0BAAA;AArER;AAwEM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAtER;;AA6EA;EACE,8BAAA;EACA,wBAAA;AA1EF;AA4EE;EACE,qFACE;AA3EN;AA8EI;EACE,YAAA;AA5EN;;AAkFA;EACE,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,qCAAA;EACA,2BAAA;AA/EF;AAiFE;EACE,qBAAA;AA/EJ;AAkFE;EACE,uBAAA;EACA,UAAA;EACA,gBAAA;AAhFJ;AAkFI;EACE,gBAAA;EACA,gBAAA;AAhFN;AAkFM;EACE,aAAA;AAhFR;AAqFI;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnFN;AAsFI;EACE,aAAA;EACA,sCAAA;EACA,6BAAA;EACA,mBAAA;AApFN;AAuFI;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AArFN;AAwFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAtFN;AAyFI;EACE,2BAAA;EACA,YAAA;EACA,mBAAA;AAvFN;AA0FI;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAxFN;AA0FM;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAxFR;AA2FM;EACE,WAAA;EACA,gBAAA;AAzFR;AA6FI;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AA3FN;AA6FM;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AA3FR;AA8FM;EACE,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AA5FR;AA+FM;EACE,mBAAA;EACA,WAAA;AA7FR;AAkGM;EACE,aAAA;EACA,gCAAA;EACA,6BAAA;AAhGR;AAkGQ;EACE,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAhGV;AAmGQ;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAjGV;AAsGI;EACE,gBAAA;EACA,0BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AApGN;AAsGM;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AApGR;AAwGI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAtGN;AAwGM;EACE,kBAAA;EACA,iBAAA;EACA,2BAAA;AAtGR;AA0GI;EACE,aAAA;EACA,8BAAA;EACA,0BAAA;AAxGN;AA2GI;EACE,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAzGN;AA2GM;EACE,iBAAA;EACA,4BAAA;AAzGR;AA4GM;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA1GR;AA8GI;EACE,WAAA;AA5GN;AA+GI;EACE,eAAA;AA7GN;;AAoHE;EACE,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,qCAAA;AAjHJ;AAmHI;EACE,kCAAA;AAjHN;AAsHI;EACE,wEAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;AApHN;AAsHM;EACE,gBAAA;EACA,yCAAA;AApHR;AAsHQ;EACE,iDAAA;AApHV;AAwHM;EACE,+BAAA;EACA,YAAA;EACA,yBAAA;AAtHR;AAwHQ;EACE,UAAA;EACA,qBAAA;AAtHV;;AA8HA;EAEI;IACE,eAAA;EA5HJ;EAgII;IACE,iBAAA;IACA,sBAAA;IACA,uBAAA;EA9HN;EAgIM;IACE,sBAAA;IACA,eAAA;EA9HR;EAmIE;IACE,sBAAA;EAjIJ;EAmII;IACE,WAAA;IACA,qBAAA;EAjIN;EAoII;IACE,WAAA;IACA,YAAA;EAlIN;EAsIE;IACE,sBAAA;IACA,WAAA;EApIJ;EAsII;;;IAGE,WAAA;IACA,uBAAA;EApIN;EAwIE;IACE,iCAAA;IACA,kCAAA;IACA,SAAA;EAtIJ;EAyIE;IACE,WAAA;EAvIJ;EA0IE;IACE,WAAA;EAxIJ;EA2IE;IACE,aAAA;EAzIJ;EA2II;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EAzIN;EA4II;IACE,WAAA;IACA,aAAA;EA1IN;EA4IM;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EA1IR;EA4IQ;IACE,eAAA;IACA,gBAAA;IACA,UAAA;EA1IV;AACF;AAiJA;EAGM;IACE,kBAAA;IACA,0BAAA;EAjJN;EA0JM;;;IACE,aAAA;EAtJR;AACF;AA6JA;EAGI;;;IAGE,wBAAA;EA7JJ;EAiKA;IACE,qBAAA;IACA,2BAAA;IACA,2BAAA;EA/JF;EAiKE;IACE,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,oBAAA;IACA,qBAAA;IACA,2BAAA;EA/JJ;EAiKI;IACE,wBAAA;EA/JN;AACF;AAqKA;EACE,WAAA;EACA,YAAA;EACA,kCAAA;AAnKF;;AAsKA;EACE;IACE,uBAAA;EAnKF;EAsKA;IACE,yBAAA;EApKF;AACF;AAwKA;EACE;IACE,UAAA;IACA,2BAAA;EAtKF;EAyKA;IACE,UAAA;IACA,wBAAA;EAvKF;AACF;AA0KA;EACE;IACE,4BAAA;EAxKF;EA2KA;IACE,2BAAA;EAzKF;AACF;AA4KA;EACE;IACE,UAAA;IACA,2BAAA;EA1KF;EA6KA;IACE,UAAA;IACA,wBAAA;EA3KF;AACF;AA8KA;EACE,kCAAA;AA5KF;;AAgLA;;;EAGE,0DAAA;EACA,gCAAA;EACA,aAAA;AA7KF;;AAiLA;EACE,wEAAA;AA9KF;;AAiLA;EACE,sBAAA;EACA,+BAAA;AA9KF;;AAoLI;EACE,cAAA;AAjLN;AAoLI;EACE,cAAA;AAlLN;AAqLI;EACE,6DAAA;AAnLN;AAsLI;;EAEE,qDAAA;AApLN;;AA0LA;EAEE,cAAA;AAxLF;AA2LE;;;;EAIE,cAAA;AAzLJ;AA6LE;;EAEE,kCAAA;EACA,cAAA;EACA,2CAAA;AA3LJ;AA+LE;EACE,wEAAA;EACA,cAAA;EACA,kDAAA;AA7LJ;AAiME;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;AA/LJ;AAkME;EACE,cAAA;AAhMJ;AAoME;EACE,mCAAA;EACA,cAAA;EACA,8BAAA;AAlMJ;AAsME;EACE,cAAA;AApMJ;AAuME;EACE,cAAA;EACA,qBAAA;AArMJ;AAwME;EACE,cAAA;EACA,qBAAA;AAtMJ;;AA2MA;EACE,0BAAA;AAxMF;;AA2MA;EACE,2BAAA;EACA,oCAAA;EACA,0CAAA;AAxMF;;AA2MA;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AAxMF;;AA2MA;EACE,sCAAA;AAxMF;;AA8MI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AA3MN;AA6MM;EACE,cAAA;AA3MR;AA+MI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AA7MN;AAiNE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AA/MJ;AAiNI;EACE,aAAA;EACA,cAAA;AA/MN;AAoNE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;AAlNJ;AAoNI;EACE,2BAAA;EACA,qDAAA;AAlNN;AAqNI;EACE,uCAAA;EACA,gBAAA;EACA,iDAAA;AAnNN;AAqNM;EACE,wEAAA;AAnNR;AAsNM;EACE,wEAAA;EACA,cAAA;AApNR;AAsNQ;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;AApNV;AAwNM;EACE,SAAA;EACA,gBAAA;AAtNR;AA0NI;EACE,4BAAA;AAxNN;AA6NE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AA3NJ;AA6NI;EACE,2BAAA;EACA,0CAAA;AA3NN;AA8NI;EACE,6DAAA;AA5NN;AA+NI;EACE,yBAAA;EACA,cAAA;AA7NN;AA+NM;EACE,mBAAA;EACA,qBAAA;AA7NR;AAiOI;EACE,yBAAA;EACA,cAAA;AA/NN;AAiOM;EACE,mBAAA;EACA,qBAAA;AA/NR;AAmOI;EACE,yBAAA;EACA,cAAA;AAjON;AAmOM;EACE,mBAAA;EACA,qBAAA;AAjOR;AAqOI;EACE,mBAAA;AAnON;AAwOE;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,wCAAA;AAtOJ;AAwOI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAtON;AAyOI;EACE,oBAAA;AAvON;AA4OE;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;AA1OJ;AA4OI;EACE,wEAAA;AA1ON;AA6OI;EACE,wEAAA;AA3ON;AA8OI;EACE,wEAAA;AA5ON;;AAkPA;EACE,6DAAA;EACA,aAAA;EACA,mBAAA;AA/OF;AAiPE;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,2GACE;EAGF,aAAA;EACA,kBAAA;EACA,kBAAA;AAlPJ;AAoPI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,0BAAA;AAlPN;;AAwPA;EACE,8BAAA;EACA,wBAAA;AArPF;AAuPE;EACE,wFACE;AAtPN;;AA4PA;EACE,uBAAA;EACA,8BAAA;EACA,gBAAA;AAzPF;AA2PE;EACE,qBAAA;AAzPJ;AA4PE;EACE,uBAAA;EACA,UAAA;EACA,gBAAA;AA1PJ;AA4PI;EACE,gBAAA;EACA,gBAAA;AA1PN;AA4PM;EACE,aAAA;AA1PR;;AAiQA;EAGM;IACE,iBAAA;IACA,sBAAA;IACA,uBAAA;EAhQN;EAkQM;IACE,sBAAA;IACA,eAAA;EAhQR;EAqQE;IACE,sBAAA;IACA,sBAAA;EAnQJ;EAqQI;IACE,WAAA;IACA,uBAAA;EAnQN;EAuQE;IACE,aAAA;EArQJ;EAuQI;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EArQN;AACF;AA0QA;EAGM;IACE,sBAAA;IACA,kCAAA;IACA,SAAA;EA1QN;EA6QI;IACE,eAAA;EA3QN;EA8QI;IACE,WAAA;EA5QN;EA8QM;IACE,SAAA;IACA,YAAA;EA5QR;EA8QQ;IACE,aAAA;EA5QV;EA+QQ;IACE,yBAAA;EA7QV;AACF;AAqRA;EAGI;;;;IAIE,wBAAA;EArRJ;EAyRA;IACE,qBAAA;IACA,2BAAA;IACA,2BAAA;EAvRF;EAyRE;IACE,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,oBAAA;IACA,qBAAA;IACA,2BAAA;EAvRJ;EAyRI;IACE,wBAAA;EAvRN;AACF;AA6RA;EACE,WAAA;EACA,YAAA;AA3RF;;AA+RA;EACE;IACE,UAAA;IACA,2BAAA;EA5RF;EA+RA;IACE,UAAA;IACA,wBAAA;EA7RF;AACF;AAgSA;EACE,kCAAA;AA9RF;;AAkSA;;;EAGE,wDAAA;EACA,gCAAA;AA/RF;;AAmSA;EACE,wEAAA;AAhSF;;AAmSA;EACE,sBAAA;EACA,+BAAA;AAhSF;;AAoSA;EAEI;IACE,cAAA;EAlSJ;EAqSE;IACE,cAAA;EAnSJ;EAsSE;IACE,6DAAA;EApSJ;AACF","sourcesContent":["// Customer Agreement Report Styles - Modern Design Inspired by AppHeader\n.customer-agreement-report {\n\n  // Container padding fix\n  .container-fluid {\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n\n  .page-header {\n    .page-title {\n      font-size: 2rem;\n      font-weight: 600;\n      color: #667eea;\n      margin-bottom: 0.5rem;\n      display: flex;\n      align-items: center;\n\n      i {\n        color: #764ba2;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n      }\n    }\n\n    .page-subtitle {\n      font-size: 1rem;\n      line-height: 1.5;\n      margin-bottom: 0;\n      color: #6c757d;\n    }\n  }\n\n  .form-label-required {\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 0.5rem;\n\n    &::after {\n      content: ' *';\n      color: #ef4444;\n    }\n  }\n\n  // Enhanced card styling with AppHeader inspiration\n  .card {\n    border: none;\n    border-radius: 16px;\n    transition: all 0.3s ease;\n    overflow: hidden;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;\n    }\n\n    &.selection-card {\n      backdrop-filter: blur(20px);\n      background: rgba(255, 255, 255, 0.95);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(33, 37, 41, 0.95);\n        border-color: rgba(102, 126, 234, 0.2);\n      }\n    }\n\n    &.details-card {\n      background: rgba(255, 255, 255, 0.98);\n      backdrop-filter: blur(20px);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(33, 37, 41, 0.98);\n      }\n    }\n\n    .card-header {\n      border-radius: 16px 16px 0 0 !important;\n      padding: 1.5rem 2rem;\n      border-bottom: none;\n      position: relative;\n\n      &.gradient-header {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n        color: white !important;\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: -1px;\n          left: 0;\n          right: 0;\n          height: 1px;\n          background: linear-gradient(90deg,\n              transparent 0%,\n              rgba(255, 255, 255, 0.3) 50%,\n              transparent 100%);\n        }\n\n        h5 {\n          margin: 0;\n          font-weight: 600;\n          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n        }\n      }\n\n      &.details-header {\n        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n        color: #374151;\n        border-bottom: 1px solid rgba(102, 126, 234, 0.1);\n\n        .details-header-content {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n        }\n\n        .details-title {\n          font-weight: 600;\n          color: #667eea;\n          margin-bottom: 0.5rem;\n\n          i {\n            color: #764ba2;\n          }\n        }\n\n        .details-badges {\n          display: flex;\n          gap: 0.75rem;\n          flex-wrap: wrap;\n        }\n      }\n    }\n\n    .card-body {\n      border-radius: 0 0 16px 16px;\n      padding: 2rem;\n    }\n  }\n\n  // Action buttons styling\n  .action-buttons-group {\n    display: flex;\n    gap: 12px;\n    width: 100%;\n\n    .btn-report-generate {\n      flex: 1;\n      padding: 12px 24px;\n      font-weight: 600;\n      border-radius: 12px;\n      font-size: 0.95rem;\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      color: white;\n      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n      transition: all 0.3s ease;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);\n        background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n\n      i {\n        margin-right: 8px;\n      }\n    }\n\n    .btn-clear {\n      padding: 12px 20px;\n      font-weight: 600;\n      border-radius: 12px;\n      font-size: 0.95rem;\n      background: transparent;\n      border: 2px solid #e5e7eb;\n      color: #6b7280;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n\n      &:hover:not(:disabled) {\n        border-color: #ef4444;\n        color: #ef4444;\n        background: rgba(239, 68, 68, 0.05);\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      .clear-icon {\n        font-size: 1.2rem;\n        font-weight: 700;\n        line-height: 1;\n      }\n    }\n  }\n\n  .action-buttons-export {\n    display: flex;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n\n    .btn-action-preview,\n    .btn-action-print,\n    .btn-action-excel {\n      border-radius: 10px;\n      padding: 8px 16px;\n      font-weight: 500;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow: hidden;\n      border: 2px solid transparent;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 0;\n        height: 0;\n        background: rgba(255, 255, 255, 0.2);\n        border-radius: 50%;\n        transform: translate(-50%, -50%);\n        transition: all 0.5s ease;\n      }\n\n      &:hover::before {\n        width: 200px;\n        height: 200px;\n      }\n\n      .btn-text {\n        position: relative;\n        z-index: 2;\n      }\n\n      i {\n        position: relative;\n        z-index: 2;\n      }\n    }\n\n    .btn-action-preview {\n      background: rgba(13, 202, 240, 0.1);\n      border-color: rgba(13, 202, 240, 0.2);\n      color: #0dcaf0;\n\n      &:hover {\n        background: linear-gradient(135deg, #0dcaf0 0%, #0aa2c0 100%);\n        border-color: #0dcaf0;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(13, 202, 240, 0.4);\n      }\n    }\n\n    .btn-action-print {\n      background: rgba(108, 117, 125, 0.1);\n      border-color: rgba(108, 117, 125, 0.2);\n      color: #6c757d;\n\n      &:hover {\n        background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n        border-color: #6c757d;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(108, 117, 125, 0.4);\n      }\n    }\n\n    .btn-action-excel {\n      background: rgba(25, 135, 84, 0.1);\n      border-color: rgba(25, 135, 84, 0.2);\n      color: #198754;\n\n      &:hover {\n        background: linear-gradient(135deg, #198754 0%, #157347 100%);\n        border-color: #198754;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(25, 135, 84, 0.4);\n      }\n    }\n  }\n\n  // Badge enhancements\n  .detail-badge {\n    font-weight: 500;\n    border-radius: 8px;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.875rem;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n\n    &.customer-badge {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      border-color: #667eea;\n    }\n\n    &.code-badge {\n      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n      color: white;\n      border-color: #f093fb;\n    }\n\n    &.date-badge {\n      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n      color: white;\n      border-color: #4facfe;\n    }\n  }\n\n  // Alert styling\n  .alert {\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 1.25rem;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n    &.alert-danger {\n      background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n      color: #dc2626;\n      border-left: 4px solid #dc3545;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(220, 53, 69, 0.15);\n        color: #f8d7da;\n      }\n    }\n\n    i {\n      margin-right: 0.5rem;\n      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\n    }\n  }\n}\n\n// A4 Preview Styling - Clean and professional\n.agreement-a4-preview {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  padding: 2rem;\n  border-radius: 16px;\n\n  >* {\n    width: 210mm;\n    min-height: 297mm;\n    margin: 0 auto;\n    background: white;\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.05),\n      0 20px 40px rgba(0, 0, 0, 0.1),\n      0 4px 8px rgba(0, 0, 0, 0.05);\n    padding: 12mm;\n    border-radius: 8px;\n    position: relative;\n\n    // Clean professional look without colored borders\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 2px;\n      background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n      border-radius: 8px 8px 0 0;\n      opacity: 0.3;\n    }\n  }\n\n  // Two page preview styling\n  &.two-page-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n    padding: 2rem;\n\n    >* {\n      width: auto;\n      min-height: auto;\n      margin: 0;\n      background: transparent;\n      box-shadow: none;\n      padding: 0;\n      border-radius: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    .preview-page {\n      width: 210mm;\n      min-height: 297mm;\n      background: white;\n      box-shadow:\n        0 0 0 1px rgba(0, 0, 0, 0.1),\n        0 20px 40px rgba(0, 0, 0, 0.15),\n        0 4px 8px rgba(0, 0, 0, 0.08);\n      padding: 12mm;\n      border-radius: 8px;\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 3px;\n        background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n        border-radius: 8px 8px 0 0;\n      }\n\n      .page-label {\n        position: absolute;\n        top: -28px;\n        right: 12px;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        padding: 4px 12px;\n        border-radius: 6px 6px 0 0;\n        font-size: 12px;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n      }\n    }\n  }\n}\n\n// Modal preview specific styling\n.modal-preview {\n  background: #f8fafc !important;\n  padding: 1rem !important;\n\n  >* {\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.05),\n      0 10px 20px rgba(0, 0, 0, 0.08) !important;\n\n    &::before {\n      opacity: 0.5;\n    }\n  }\n}\n\n// Agreement preview card\n.agreement-preview-card {\n  border: none !important;\n  border-radius: 16px !important;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(20px);\n\n  .card-body {\n    padding: 0 !important;\n  }\n\n  .agreement-a4-preview {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n\n    >* {\n      box-shadow: none;\n      border-radius: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    // Template içindeki class'lar için stiller\n    .agreement-wrap {\n      width: 100%;\n      border: 2px solid #000;\n      border-radius: 4px;\n      overflow: hidden;\n      background: #ffffff;\n    }\n\n    .header-grid {\n      display: grid;\n      grid-template-columns: 100px 1fr 180px;\n      border-bottom: 2px solid #000;\n      background: #ffffff;\n    }\n\n    .logo-cell {\n      border-right: 2px solid #000;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 12px 8px;\n      background: #ffffff;\n    }\n\n    .title-cell {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 700;\n      font-size: 24px;\n      color: #000;\n      text-align: center;\n      padding: 12px;\n    }\n\n    .meta-cell {\n      border-left: 2px solid #000;\n      padding: 8px;\n      background: #ffffff;\n    }\n\n    .meta-table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 13px;\n\n      td {\n        border: 1px solid #000;\n        padding: 6px 8px;\n        background: #ffffff;\n        vertical-align: middle;\n      }\n\n      strong {\n        color: #000;\n        font-weight: 600;\n      }\n    }\n\n    .customer-info-table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 14px;\n      margin: 0;\n\n      td {\n        border: 1px solid #000;\n        padding: 10px 12px;\n        background: #ffffff;\n        vertical-align: middle;\n      }\n\n      .label-cell {\n        background: #f8f9fa;\n        font-weight: 600;\n        width: 15%;\n        color: #000;\n      }\n\n      .value-cell {\n        background: #ffffff;\n        color: #000;\n      }\n    }\n\n    .section {\n      .row {\n        display: grid;\n        grid-template-columns: 200px 1fr;\n        border-bottom: 1px solid #000;\n\n        .label {\n          border-right: 1px solid #000;\n          font-weight: 600;\n          padding: 12px 14px;\n          background: #f8f9fa;\n          color: #000;\n          display: flex;\n          align-items: center;\n          font-size: 14px;\n        }\n\n        .value {\n          padding: 12px 14px;\n          background: #ffffff;\n          color: #000;\n          display: flex;\n          align-items: center;\n          min-height: 45px;\n          font-size: 14px;\n        }\n      }\n    }\n\n    .notes {\n      min-height: 60px;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n      padding: 12px;\n      background: #ffffff;\n\n      .note-title {\n        font-weight: 700;\n        margin-bottom: 8px;\n        color: #000;\n        font-size: 15px;\n      }\n    }\n\n    .terms {\n      font-size: 16px;\n      line-height: 1.5;\n      padding: 12px;\n      background: #f8f9fa;\n      color: #333;\n\n      >div {\n        margin-bottom: 4px;\n        padding-left: 8px;\n        border-left: 2px solid #ddd;\n      }\n    }\n\n    .signatures {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      border-top: 2px solid #000;\n    }\n\n    .sig-cell {\n      border-left: 1px solid #000;\n      padding: 20px 16px;\n      height: 100px;\n      text-align: center;\n      background: #ffffff;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      &:first-child {\n        border-left: none;\n        border-right: 1px solid #000;\n      }\n\n      strong {\n        color: #000;\n        margin-bottom: 6px;\n        font-size: 15px;\n        font-weight: 700;\n      }\n    }\n\n    .muted {\n      color: #666;\n    }\n\n    .small {\n      font-size: 12px;\n    }\n  }\n}\n\n// Modal enhancements\n.modal {\n  .modal-content {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    backdrop-filter: blur(20px);\n    background: rgba(255, 255, 255, 0.98);\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.98);\n    }\n  }\n\n  .modal-header {\n    &.gradient-header {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n      color: white !important;\n      border-radius: 20px 20px 0 0;\n      padding: 1.5rem 2rem;\n      border-bottom: none;\n\n      .modal-title {\n        font-weight: 600;\n        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n\n        i {\n          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n        }\n      }\n\n      .btn-close {\n        filter: brightness(0) invert(1);\n        opacity: 0.8;\n        transition: all 0.2s ease;\n\n        &:hover {\n          opacity: 1;\n          transform: scale(1.1);\n        }\n      }\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .customer-agreement-report {\n    .container-fluid {\n      padding: 0 1rem;\n    }\n\n    .page-header {\n      .page-title {\n        font-size: 1.5rem;\n        flex-direction: column;\n        align-items: flex-start;\n\n        i {\n          margin-bottom: 0.25rem;\n          margin-right: 0;\n        }\n      }\n    }\n\n    .action-buttons-group {\n      flex-direction: column;\n\n      .btn-report-generate {\n        width: 100%;\n        margin-bottom: 0.5rem;\n      }\n\n      .btn-clear {\n        width: 100%;\n        height: 48px;\n      }\n    }\n\n    .action-buttons-export {\n      flex-direction: column;\n      width: 100%;\n\n      .btn-action-preview,\n      .btn-action-print,\n      .btn-action-excel {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n\n    .details-header-content {\n      flex-direction: column !important;\n      align-items: flex-start !important;\n      gap: 1rem;\n    }\n\n    .details-badges {\n      width: 100%;\n    }\n\n    .action-buttons-export {\n      width: 100%;\n    }\n\n    .agreement-a4-preview {\n      padding: 1rem;\n\n      >* {\n        width: 100%;\n        min-height: auto;\n        padding: 8mm;\n      }\n\n      &.two-page-preview {\n        gap: 1.5rem;\n        padding: 1rem;\n\n        .preview-page {\n          width: 100%;\n          min-height: auto;\n          padding: 8mm;\n\n          .page-label {\n            font-size: 10px;\n            padding: 3px 8px;\n            top: -24px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .customer-agreement-report {\n    .details-badges {\n      .detail-badge {\n        font-size: 0.75rem;\n        padding: 0.375rem 0.625rem;\n      }\n    }\n\n    .action-buttons-export {\n\n      .btn-action-preview,\n      .btn-action-print,\n      .btn-action-excel {\n        .btn-text {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .customer-agreement-report {\n\n    .page-header,\n    .card:not(.agreement-preview-card),\n    .alert {\n      display: none !important;\n    }\n  }\n\n  .agreement-a4-preview {\n    padding: 0 !important;\n    background: none !important;\n    border-radius: 0 !important;\n\n    >* {\n      width: auto !important;\n      min-height: auto !important;\n      box-shadow: none !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      border-radius: 0 !important;\n\n      &::before {\n        display: none !important;\n      }\n    }\n  }\n}\n\n// Loading states\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// Animation enhancements\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agreement-preview-card {\n  animation: slideInUp 0.5s ease-out;\n}\n\n// Focus states for accessibility\n.btn:focus,\n.form-control:focus,\n.form-select:focus {\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15) !important;\n  border-color: #667eea !important;\n  outline: none;\n}\n\n// Hover effects for interactive elements\n.card:hover .details-header {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;\n}\n\n.detail-badge:hover {\n  transform: scale(1.05);\n  transition: transform 0.2s ease;\n}\n\n// Dark mode support\n[data-coreui-theme=\"dark\"] {\n  .customer-agreement-report {\n    .page-title {\n      color: #8da3f0;\n    }\n\n    .page-subtitle {\n      color: #9ca3af;\n    }\n\n    .agreement-a4-preview {\n      background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n    }\n\n    .selection-card,\n    .details-card {\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;\n    }\n  }\n}\n\n// Scoped dark mode readability fixes (page-only)\n[data-coreui-theme=\"dark\"] .customer-agreement-report {\n  // Base text color\n  color: #e5e7eb;\n\n  // Labels and helper text\n  .form-label-required,\n  .page-subtitle,\n  label,\n  small {\n    color: #e5e7eb;\n  }\n\n  // Cards\n  .card.selection-card,\n  .card.details-card {\n    background: rgba(17, 24, 39, 0.95);\n    color: #e5e7eb;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  // Details header contrast\n  .details-card .details-header {\n    background: linear-gradient(135deg, #111827 0%, #1f2937 100%) !important;\n    color: #e5e7eb;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  // Inputs / selects within this page\n  input.form-control,\n  .form-select {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: #374151 !important;\n  }\n\n  input.form-control::placeholder {\n    color: #9ca3af;\n  }\n\n  // Alerts\n  .alert.alert-danger {\n    background: rgba(185, 28, 28, 0.15);\n    color: #fecaca;\n    border-left: 4px solid #ef4444;\n  }\n\n  // Buttons\n  .btn-report-generate {\n    color: #ffffff;\n  }\n\n  .btn-clear {\n    color: #9ca3af;\n    border-color: #4b5563;\n  }\n\n  .btn-clear:hover {\n    color: #f87171;\n    border-color: #ef4444;\n  }\n}\n\n// Utility classes\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.glassmorphism {\n  backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.fade-in-up {\n  animation: fadeInUp 0.5s ease forwards;\n}\n\n// Customer Agreement Report Styles\n.customer-agreement-report {\n  .page-header {\n    .page-title {\n      font-size: 2rem;\n      font-weight: 600;\n      color: #1e40af;\n      margin-bottom: 0.5rem;\n      display: flex;\n      align-items: center;\n\n      i {\n        color: #3b82f6;\n      }\n    }\n\n    .page-subtitle {\n      font-size: 1rem;\n      line-height: 1.5;\n      margin-bottom: 0;\n    }\n  }\n\n  .form-label-required {\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 0.5rem;\n\n    &::after {\n      content: ' *';\n      color: #ef4444;\n    }\n  }\n\n  // Enhanced card styling\n  .card {\n    border: none;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;\n    }\n\n    .card-header {\n      border-radius: 12px 12px 0 0 !important;\n      padding: 1.25rem;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n      &.bg-primary {\n        background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;\n      }\n\n      &.bg-light {\n        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;\n        color: #374151;\n\n        .badge {\n          font-size: 0.75rem;\n          padding: 0.375rem 0.75rem;\n          border-radius: 6px;\n        }\n      }\n\n      h5 {\n        margin: 0;\n        font-weight: 600;\n      }\n    }\n\n    .card-body {\n      border-radius: 0 0 12px 12px;\n    }\n  }\n\n  // Button enhancements\n  .btn {\n    border-radius: 8px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    border: none;\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    }\n\n    &.btn-primary {\n      background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);\n    }\n\n    &.btn-outline-info {\n      border: 1px solid #06b6d4;\n      color: #06b6d4;\n\n      &:hover {\n        background: #06b6d4;\n        border-color: #06b6d4;\n      }\n    }\n\n    &.btn-outline-secondary {\n      border: 1px solid #6b7280;\n      color: #6b7280;\n\n      &:hover {\n        background: #6b7280;\n        border-color: #6b7280;\n      }\n    }\n\n    &.btn-outline-success {\n      border: 1px solid #10b981;\n      color: #10b981;\n\n      &:hover {\n        background: #10b981;\n        border-color: #10b981;\n      }\n    }\n\n    i {\n      font-size: 0.875rem;\n    }\n  }\n\n  // Alert styling\n  .alert {\n    border: none;\n    border-radius: 10px;\n    padding: 1rem 1.25rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n    &.alert-danger {\n      background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n      color: #dc2626;\n      border-left: 4px solid #dc2626;\n    }\n\n    i {\n      margin-right: 0.5rem;\n    }\n  }\n\n  // Badge enhancements\n  .badge {\n    font-weight: 500;\n    border-radius: 6px;\n    padding: 0.5rem 0.75rem;\n\n    &.bg-info {\n      background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%) !important;\n    }\n\n    &.bg-secondary {\n      background: linear-gradient(135deg, #64748b 0%, #475569 100%) !important;\n    }\n\n    &.bg-success {\n      background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n    }\n  }\n}\n\n// A4 Preview Styling\n.agreement-a4-preview {\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  padding: 2rem;\n  border-radius: 12px;\n\n  >* {\n    width: 210mm;\n    min-height: 297mm;\n    margin: 0 auto;\n    background: white;\n    box-shadow:\n      0 0 0 1px rgba(37, 99, 235, 0.1),\n      0 20px 40px rgba(0, 0, 0, 0.1),\n      0 4px 8px rgba(0, 0, 0, 0.05);\n    padding: 12mm;\n    border-radius: 8px;\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 4px;\n      background: linear-gradient(90deg, #3b82f6 0%, #1e40af 100%);\n      border-radius: 8px 8px 0 0;\n    }\n  }\n}\n\n// Modal preview specific styling\n.modal-preview {\n  background: #f8fafc !important;\n  padding: 1rem !important;\n\n  >* {\n    box-shadow:\n      0 0 0 1px rgba(37, 99, 235, 0.1),\n      0 10px 20px rgba(0, 0, 0, 0.08) !important;\n  }\n}\n\n// Agreement preview card\n.agreement-preview-card {\n  border: none !important;\n  border-radius: 16px !important;\n  overflow: hidden;\n\n  .card-body {\n    padding: 0 !important;\n  }\n\n  .agreement-a4-preview {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n\n    >* {\n      box-shadow: none;\n      border-radius: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .customer-agreement-report {\n    .page-header {\n      .page-title {\n        font-size: 1.5rem;\n        flex-direction: column;\n        align-items: flex-start;\n\n        i {\n          margin-bottom: 0.25rem;\n          margin-right: 0;\n        }\n      }\n    }\n\n    .d-flex.gap-2 {\n      flex-direction: column;\n      gap: 0.5rem !important;\n\n      .btn {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n\n    .agreement-a4-preview {\n      padding: 1rem;\n\n      >* {\n        width: 100%;\n        min-height: auto;\n        padding: 8mm;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .customer-agreement-report {\n    .card-header {\n      .d-flex {\n        flex-direction: column;\n        align-items: flex-start !important;\n        gap: 1rem;\n      }\n\n      .d-flex.gap-3 {\n        flex-wrap: wrap;\n      }\n\n      .d-flex.gap-2 {\n        width: 100%;\n\n        .btn {\n          flex: 1;\n          min-width: 0;\n\n          span {\n            display: none;\n          }\n\n          &::after {\n            content: attr(data-label);\n          }\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .customer-agreement-report {\n\n    .page-header,\n    .card:not(.agreement-preview-card),\n    .btn,\n    .alert {\n      display: none !important;\n    }\n  }\n\n  .agreement-a4-preview {\n    padding: 0 !important;\n    background: none !important;\n    border-radius: 0 !important;\n\n    >* {\n      width: auto !important;\n      min-height: auto !important;\n      box-shadow: none !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      border-radius: 0 !important;\n\n      &::before {\n        display: none !important;\n      }\n    }\n  }\n}\n\n// Loading states\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n// Animation enhancements\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agreement-preview-card {\n  animation: slideInUp 0.5s ease-out;\n}\n\n// Focus states for accessibility\n.btn:focus,\n.form-control:focus,\n.form-select:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n  border-color: #3b82f6 !important;\n}\n\n// Hover effects for interactive elements\n.card:hover .card-header.bg-light {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;\n}\n\n.badge:hover {\n  transform: scale(1.05);\n  transition: transform 0.2s ease;\n}\n\n// Dark mode support (if needed)\n@media (prefers-color-scheme: dark) {\n  .customer-agreement-report {\n    .page-title {\n      color: #60a5fa;\n    }\n\n    .page-subtitle {\n      color: #9ca3af;\n    }\n\n    .agreement-a4-preview {\n      background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
